/**
 * Vendor program header block
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Table, TableBody, TableRow, TableCell, Typography } from '@mui/material';

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
      flex: 1,
  },
  [theme.breakpoints.up('sm')]: {
    tblCellLogoCol: {
        paddingTop: 0,
        paddingLeft: 0,
        paddingBottom: 0,
        paddingRight: 10,
        width: 52,
        maxWidth: 52,
        verticalAlign: 'top',
        borderBottom: 0,
    },
    tblCellDescCol: {
        paddingTop: 0,
        paddingLeft: 0,
        paddingBottom: 0,
        paddingRight: 0,
        width: 948,
        verticalAlign: 'middle',
        borderBottom: 0,
    },
},
[theme.breakpoints.up('xs')]: {
    tblCellLogoCol: {
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 10,
        width: 52,
        maxWidth: 52,
        verticalAlign: 'top',
        borderBottom: 0,
    },
    tblCellDescCol: {
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,
        verticalAlign: 'middle',
        borderBottom: 0,
    }
  }

});

class VendorPartnerProgramBlockHeader extends Component {

 

    render() {
      const classes = this.props.classes;

      return (
        <Table >
        <TableBody>
            <TableRow>
                <TableCell className={classes.tblCellLogoCol}>
                  <img alt="Logo" height="52px" src={this.props.vpp.accountTByVendorId.logo} />
                </TableCell>
                <TableCell className={classes.tblCellDescCol}>
                    <Typography variant="h6">{this.props.vpp.programName}</Typography>
                    <Typography variant="body2">{this.props.vpp.description}</Typography>
                </TableCell>
            </TableRow>
        </TableBody>
    </Table>

        );
    }

}
  
export default withStyles(styleSheet)(VendorPartnerProgramBlockHeader);
